import React from "react";


import {
Document,
Page,
Text,
View,
Image,
StyleSheet
} from "@react-pdf/renderer";



const styles = StyleSheet.create({


page:{

padding:35,

backgroundColor:"#f5f5f5",

fontSize:11

},



header:{

backgroundColor:"#800000",

padding:20,

borderRadius:8,

marginBottom:20,

color:"#ffffff"

},



title:{

fontSize:20,

fontWeight:"bold",

marginBottom:8

},



subtitle:{

fontSize:11

},



section:{

backgroundColor:"#ffffff",

padding:15,

borderRadius:8,

marginBottom:15

},



sectionTitle:{

fontSize:14,

fontWeight:"bold",

color:"#800000",

marginBottom:10

},



table:{


display:"table",

width:"100%",

borderStyle:"solid",

borderWidth:1,

borderColor:"#dddddd"


},



tableRow:{

flexDirection:"row"

},



tableHeader:{


backgroundColor:"#4b0000",

color:"#ffffff",

fontWeight:"bold"


},



tableCell:{


padding:8,

borderRightWidth:1,

borderBottomWidth:1,

borderColor:"#dddddd"

},



rankCell:{

width:"12%"

},



nameCell:{

width:"38%"

},



classCell:{

width:"25%"

},



averageCell:{

width:"25%",

textAlign:"center"

},



footer:{

marginTop:20,

textAlign:"center",

fontSize:9,

color:"#666"

}


});







const HighAveragesPagePDF=({data})=>{


if(!data){

return null;

}




const students=data.students || [];





return(


<Document>


<Page

size="A4"

style={styles.page}

>



<View

style={styles.header}

>


<Text

style={styles.title}

>

High Performing Students Report

</Text>



<Text

style={styles.subtitle}

>

Academic Year:

{" "}

{data.academic_year}

</Text>



<Text

style={styles.subtitle}

>

Grade Class:

{" "}

{data.grade_class}

</Text>



</View>






<View

style={styles.section}

>


<Text

style={styles.sectionTitle}

>

Top Students

</Text>





<View

style={styles.table}

>



<View

style={[

styles.tableRow,

styles.tableHeader

]}

>


<Text

style={[

styles.tableCell,

styles.rankCell

]}

>

Rank

</Text>



<Text

style={[

styles.tableCell,

styles.nameCell

]}

>

Student Name

</Text>



<Text

style={[

styles.tableCell,

styles.classCell

]}

>

Grade Class

</Text>



<Text

style={[

styles.tableCell,

styles.averageCell

]}

>

Average

</Text>



</View>







{

students.map((student,index)=>(


<View

key={index}

style={styles.tableRow}

>



<Text

style={[

styles.tableCell,

styles.rankCell

]}

>

{student.rank}

</Text>





<Text

style={[

styles.tableCell,

styles.nameCell

]}

>

{student.student_name}

</Text>





<Text

style={[

styles.tableCell,

styles.classCell

]}

>

{student.grade_class}

</Text>





<Text

style={[

styles.tableCell,

styles.averageCell

]}

>

{student.yearly_average}%

</Text>





</View>


))


}



</View>



</View>








<View

style={styles.section}

>


<Text

style={styles.sectionTitle}

>

Summary

</Text>


<Text>

Total Qualified Students:

{" "}

{students.length}

</Text>


<Text>

Report Generated From:

{" "}

{data.academic_year}

</Text>


</View>







<Text

style={styles.footer}

>

School Management System -

High Average Academic Report

</Text>





</Page>


</Document>


);


};



export default HighAveragesPagePDF;